import { fetchSesameToken } from '@/modules/api';

/**
 * Branch link the native apps claim. VidaReactNative's `parseDeeplink` maps
 * `token-login` → `/login/token-login?login_token=…`, where `@vidahealth/login`
 * redeems the sesame through Apigee's `/v1/auth/token-login-exchange`. App
 * installed → it opens deep-linked and already signed in; not installed →
 * Branch falls through to the store and replays the param post-install
 * (deferred deep link).
 */
const TOKEN_LOGIN_DEEPLINK = 'https://get.vida.co/token-login';

export const buildTokenLoginDeeplink = (loginToken: string): string =>
  `${TOKEN_LOGIN_DEEPLINK}?login_token=${encodeURIComponent(loginToken)}`;

/**
 * Mint a single-use sesame token and return the app deeplink carrying it.
 *
 * Minted on press rather than on mount: the token is single-use and short-lived,
 * so its clock should start at the moment of intent, not when the terminal
 * screen happens to render.
 *
 * Falls back to the plain download URL when the mint fails (`fetchSesameToken`
 * swallows errors and returns null), so the CTA still reaches the store — the
 * user just lands there unauthenticated instead of signed in.
 */
export async function resolveDownloadUrl(fallbackUrl: string): Promise<string> {
  const token = await fetchSesameToken();
  return token ? buildTokenLoginDeeplink(token) : fallbackUrl;
}
